<script>
    import {API_URL} from "../../env";
    import Error from "../placeholders/Error.svelte";
    import ContentLoading from "../placeholders/ContentLoading.svelte";

    window.scrollTo(0, 0);

    let data = fetchData()

    async function fetchData() {
        const res = await fetch(API_URL+'/pages/transport');
        return await res.text()
    }
</script>

<div class="container">
    <section class="info-page mt-lg-5 mb-lg-5">
        <div class="row">
            <div class="col-12">
                <div class="row">
                    <div class="col-12">
                        <h2 class="section-title">Doprava a doba dodania</h2>
                    </div>
                </div>
            </div>
            <div class="col-12">
                <div class="info-content">
                    {#await data}
                        <ContentLoading/>
                    {:then data}
                        {@html data}
                    {:catch error}
                        <Error/>
                    {/await}
                </div>
            </div>
        </div>
    </section>
</div>